module.exports = __webpack_public_path__ + "static/8-69395462fcdb1197ab875cd4cffb7f32.jpeg";